module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/company-icon-cab54fd51942a928c267f6742e3e568b.png";